/* eslint-disable react-hooks/exhaustive-deps */
import App from '../../layout/App';
import React, { useContext, useEffect, useState } from 'react';
import {  FormContent, Container } from '../../styles/styles'
import { useNavigate } from 'react-router-dom';
import api from '../../utils/api';
import './styles.css'
import Loading from '../../Components/Loading'
import MessageTitle from '../../Components/MessageTitle';
import InputSearch from '../../Components/InputSearch';
import CardPessoa from '../../Components/CardPessoa';
import InfoPage from '../../Components/infoPage';

import gestor from '../../assets/iconesMenu/icone-gestor.svg'
import { MessageContext } from '../../context/message';


const data = sessionStorage.getItem('inep')
let filter = sessionStorage.getItem('filterSM')
function PesquisarGestor() {
    const [removeLoading, setRemoveLoading] = useState(false)
    const { setErrorMessage } = useContext(MessageContext);
    const navigation = useNavigate()
    const [filtersSelect, setFiltersSelect] = useState(0)
    const [todos, setTodos] = useState([]);
    const [aux, setAux] = useState([]);
    const [dataSchool, setDataSchool] = useState('')
    const [CountChanged, setCountChanged] = useState({
        edited: 0,
        notEdited: 0
    })

    async function getDataGestor() {
        await api.get("/schoolmanager/list/" + data
        ).then(response => {
            setRemoveLoading(true)
            setTodos(response.data)
            setAux(response.data)

        }).catch((err) => {
            setRemoveLoading(true)
            setErrorMessage([{message:"Erro ao buscar gestores", ok:false  }])
        })
    }

    useEffect(() => {
        let data = JSON.parse(localStorage.getItem('dataSchool'))
        setDataSchool(data)
        getDataGestor()
    }, [])


    function filterItems(busca) {
        let Filtrados = []
        busca = busca.toUpperCase()
        if (filtersSelect !== 0) {
            Filtrados = todos.filter((aluno) => aluno.completeName.includes(busca) && aluno.wasChanged === filtersSelect)
        }
        else {
            Filtrados = todos.filter((aluno) => aluno.completeName.includes(busca))

        }
        setAux(Filtrados)
    }


    const EditGestor = (code) => {
        sessionStorage.setItem('GestorSelecionado', code)
        navigation('/gestor/editar-identificacao')
    }

    useEffect(() => {
        let edited = 0
        let notEdited = 0
        todos.map(item => {
            if (item.wasChanged) {

                return edited = edited + 1
            }
            else {
                return notEdited = notEdited + 1
            }
        })
        setCountChanged({
            edited: edited,
            notEdited: notEdited
        })
    }, [todos])

    useEffect(() => {
        filters(Number(filter))
    }, [todos])

    function filters(tipo) {
        sessionStorage.setItem('filterSM', tipo)
        setFiltersSelect(tipo)
        let list = []
        if (tipo === 1) {
            list = todos.filter((gestor) => gestor.wasChanged === true)
        }
        if (tipo === 2) {
            list = todos.filter((gestor) => gestor.wasChanged === false)
        }
        if (tipo === 0) {
            list = todos
        }
        setAux(list)


    }

    return (
        <>
            {!removeLoading && <Loading />}
            <App>
                <Container>
                    <InfoPage
                        img={gestor}
                        title={'GESTORES'}
                        key={"GT7587"}
                        edited={CountChanged.edited}
                        notEdited={CountChanged.notEdited}
                    />
                    <FormContent style={{ backgroundColor: 'transparent', border: 'none' }}>
                        <InputSearch
                            valueInput={e => filterItems(e.target.value)}
                            all={(e) => filters(0)}
                            edited={(e) => filters(1)}
                            notEdited={(e) => filters(2)}
                            totalNumber={`Número de gestores: ${dataSchool.theAmountSchoolManager}`}
                            checked={filtersSelect}
                        />
                        <div className='box-card'>
                            {
                                 !Array.isArray(aux) || aux?.length === 0 ? <MessageTitle message={'Nenhum Dado encontrado'} /> : aux.map((item, index) => {
                                    return (

                                        <CardPessoa
                                            index={index}
                                            name={item.completeName}
                                            wasChanged={item.wasChanged}
                                            onClick={() => EditGestor(item.codePersonSystem)}
                                        />

                                    )
                                })}
                        </div>

                    </FormContent>
                </Container>
            </App>
        </>
    )

}
export default PesquisarGestor;